import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import { AppsAndroidIdentifiersFilter } from "../../components/filters/AppsIdentifiersFilter/android/AppsAndroidIdentifiersFilter";
import { AppsAndroidIdentifiersFilterResult } from "../../components/filters/AppsIdentifiersFilter/android/AppsAndroidIdentifiersFilterResult";
import type { IAppsAndroidIdentifierFilter } from "../../types/androidFiltersDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

const createAndroidIdentifierFilter = (): SearchFilterInstance => ({
    key: "identifier",
    trackingName: "App Identifier",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.identifier.title" },
    tooltipText: { key: "si.find_apps.filters.identifier.android.tooltip" },
    filter: new FilterPanelBaseFilter<IAppsAndroidIdentifierFilter>({
        options: [],
    }),
    filterView: AppsAndroidIdentifiersFilter,
    filterResultView: AppsAndroidIdentifiersFilterResult,
});

export default createAndroidIdentifierFilter;
